// extracted by mini-css-extract-plugin
export default {"centered":"Faqs_centered__UY+IV","icon":"Faqs_icon__88TF7","discordBtn":"Faqs_discordBtn__hcHAQ","main_faqs":"Faqs_main_faqs__nZmxA","faqs_head":"Faqs_faqs_head__5kvVR"};